import { useEffect, useMemo, useState } from 'react';
import { contentsService } from '@/services/contents';
import useLearningContents from '@/context/contents/hook';

interface Props {
  routeId?: string;
}

const useLoadLearningContents = ({ routeId }: Props) => {
  const { loadLearningPathContents, getLearningPathContents, routeContentsHasLoaded } = useLearningContents();
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);

  const hasLoadedContents = useMemo(
    () => routeContentsHasLoaded(routeId as string),
    [routeContentsHasLoaded, routeId],
  );

  const learningPathContents = useMemo(() => {
    return getLearningPathContents(routeId as string);
  }, [getLearningPathContents, routeId]);

  const handleReload = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    if (!routeId || hasLoadedContents) return;
    setLoading(true);
    contentsService
      .getContentsByRoute(routeId)
      .then((contents) => {
        loadLearningPathContents(routeId, contents);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [routeId, reload, loadLearningPathContents, hasLoadedContents]);

  return { handleReload, loading, learningPathContents };
};

export default useLoadLearningContents;
